import { REPORT_STATUSES } from './constants'
import sampleReport from './sampleReport.json'
import type { Analysis, Report } from './stores/types'

// The report generated for the demo account's sample case (Daniel Mercer). All of its data is
// made up, so trial users can see a real report without seeing any customer's case.
export const SAMPLE_ANALYSIS: Analysis = {
  status: REPORT_STATUSES.generated,
  history: [],
  createdAt: '2026-10-25T15:52:32.448Z',
  updatedAt: '2026-10-25T15:59:50.764Z',
  metadata: {},
  report: sampleReport as Report,
}
